import { createState, useState } from "@hookstate/core";
import { Persistence } from "@hookstate/persistence";
import { ManageAlertDescription, ManageAlertState } from "../config/interfaces";

const initialState: ManageAlertState = {
  openMenu: false,
  alertDescription: {
    message: "",
    open: false,
    severity: "error",
  },
  hrefReturn: "/",
};

const actionAlertState = createState(initialState);
actionAlertState.attach(Persistence("action"));

export const setOpenAlertMenu = (open: boolean) => {
  actionAlertState.openMenu.set(open);
};

export const setAlertDescription = (error: ManageAlertDescription) => {
  actionAlertState.alertDescription.set(error);
};

export const setAlertDescriptionOpen = (open: boolean) => {
  actionAlertState.alertDescription.open.set(open);
};

export const setAlertHrefReturn = (href: string) => {
  actionAlertState.hrefReturn.set(href);
};

export const useActionAlertState = () => useState(actionAlertState);
